<template>
  <div :class="adicionarClasses(tamanhoJanela.x)">
    <button class="analise-menu__mobile-botao"
            @click="expandirMenu">
      <i class="fas fa-bars mr-1" aria-hidden="true"/>
      <small>Menu</small>
    </button>

    <p class="analise-menu__titulo">Documentos anexados</p>

    <div class="scroll-area-documentos">
    <span v-if="value.documentosAnalizaveis.length === 0"
          class="aviso">
            <ul class="analise-menu__lista">
                <li class="analise-menu__lista-item">
                    Nenhum documento encontrado
                </li>
            </ul>
        </span>

    <ul class="analise-menu__lista">
      <li v-for="(documento, newIndex) in value.documentosAnalizaveis"
          :key="newIndex"
          :class="{active: listagemSelecionada === 'LISTAGEM_DOCUMENTOS_ANEXADOS' && newIndex === indiceDocumentoSelecionado}"          class="analise-menu__lista-item"
          @click="visualizarOuAnalisarDocumento(documento, newIndex)">

          <v-tooltip top :disabled="documento.descricao.length <= 50">
              <div slot="activator">
                  <span v-if="documento && documento.descricao" style="overflow-wrap: anywhere">  {{ documento.descricao.toString().toLowerCase().replace(/\.pdf/g, '') | az-clip-text(50) }}</span>
                  <span v-else>{{ 'Arquivo sem nome...' }}</span>
              </div>

              {{documento.descricao}}
          </v-tooltip>

          <div v-if="exibirAlertaDeAcordoCom(documento.situacao)">
              <v-tooltip right max-width="400" class="">
                  <v-icon slot="activator" class="icone-reenvio"
                          :class="{'icone-reenvio-selecionado': indiceDocumentoSelecionado === newIndex}">
                    error
                  </v-icon>

                  <v-card flat class="pa-1">
                      <v-card-title>
                          <span class="primary--text font-weight-black mr-2">Situação: </span> {{ documento.situacao | filtroSituacaoAnaliseCredenciamento}}
                      </v-card-title>
                      <v-card-text class="text-xs-justify ma-0">
                          <span class="primary--text font-weight-black d-block">Motivo: </span>
                          {{documento.motivoReenvio}}
                      </v-card-text>
                  </v-card>
              </v-tooltip>
            </div>

          <span v-else-if="documento.situacao === 'ANALISADO'">
              <v-tooltip right>
                  <v-icon slot="activator" size="15" :class="{
                      'white--text': (indiceDocumentoSelecionado === newIndex),
                      'primary--text': (indiceDocumentoSelecionado !== newIndex)
                  }">check_circle</v-icon>
                  <span>Documento Analisado</span>
              </v-tooltip>
        </span>

      </li>
    </ul>

    <template v-if="existeDocumentoNaoAnalizavelComAnexoUri">
      <p class="analise-menu__titulo">Relatórios</p>

      <ul class="analise-menu__lista">
        <li v-for="(documento, index) in value.documentosNaoAnalizaveis"
            :key="index"
            :class="{active: listagemSelecionada === 'LISTAGEM_RELATORIOS' && index === indiceDocumentoSelecionado}"            class="analise-menu__lista-item"
            @click="selecionarDocumento(documento, index, 'LISTAGEM_RELATORIOS')">
          {{ documento.descricao }}
        </li>
      </ul>
    </template>
    </div>

    <acoes-solicitar-envio-documento
      :fornecedor="value.fornecedor"
      @emitirSolicitacaoEnvioNovoDocumento="solicitarEnvioNovoDocumento"
    />

   <div class="container-botoes-acoes">
     <div class="wrapper-botoes-acoes">
       <botao-solicitar-novo-documento
         :desabilitar="ehModoApenasLeitura
         &&  (!['CREDENCIADO'].includes(this.situacaoSolicitacaoCredenciamento)
         || !['NAO_CREDENCIADO'].includes(this.situacaoSolicitacaoCredenciamento))"
         colorClass="primary-color"
         class="botao-solicitar-documento analise-menu__lista-item"
         @solicitarNovoDocumento="abrirModalSolicitarNovoDocumento"/>

       <botao-baixar-todos
         :deshabilitar="false"
         colorClass="primary-color"
         texto="Baixar Todos"
         class="botao-baixar-todos analise-menu__lista-item"
         @baixarTodosDocumentos="baixarTodosDocumentos"/>
     </div>
   </div>
  </div>
</template>

<script>
import BotaoBaixarTodos from './BotaoBaixarTodos.vue'
import BotaoSolicitarNovoDocumento from './BotaoSolicitarNovoDocumento.vue'
import AcoesSolicitarEnvioDocumento from '../documento/AcoesSolicitarEnvioDocumento.vue';
import {actionTypes, mutationTypes} from "@/commons/constants";
import {mapActions} from "vuex";

export default {
  name: 'AnaliseDocumentacaoMenu',
  components:{BotaoBaixarTodos, BotaoSolicitarNovoDocumento, AcoesSolicitarEnvioDocumento},
  props: {
    value: {
      type: Object,
      required: true
    },
    situacaoSolicitacaoCredenciamento: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      modoEdicao: null,
      documentosAnexados: [],
      relatorios: [],
      situacao: null,
      documentoEstaSelecionado: false,
      indiceDocumentoSelecionado: 0,
      listagemSelecionada: 'LISTAGEM_DOCUMENTOS_ANEXADOS',
      tamanhoJanela: {
        x: 0,
        y: 0
      },
      menuEstaAberto: false,
      documentosAtivos: [],
      indiceAnterior: '',
      documentoBrancoSelecionado: false
    }
  },
  created() {
    this.modoEdicao = !!this.$route.query.edicao
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  computed: {
    deveHabilitarBotaoBaixarTodos(){
      return this.value.documentosAnalizaveis && this.value.documentosAnalizaveis.every(this.ehDocumentoAnalisado)
    },
    ehModoApenasLeitura() {
      return this.modoEdicao === false;
    },
    existeDocumentoNaoAnalizavelComAnexoUri() {
      return Array.isArray(this.value.documentosNaoAnalizaveis) &&
          this.value.documentosNaoAnalizaveis.some(doc => !!doc.uri);
    }
  },
  mounted() {
    if (this.verificarSeExisteDocumentos())
      this.selecionarDocumentoInicial()
  },
  methods: {
    visualizarOuAnalisarDocumento(documento, index){
      this.indiceDocumentoSelecionado = index
      this.listagemSelecionada = 'LISTAGEM_DOCUMENTOS_ANEXADOS'

      if(this.modoEdicao && documento.situacao === 'AGUARDANDO_ANALISE')
        this.$emit('marcarAnalisado', documento)

      this.$emit('documentoSelecionado', documento)

      if (this.tamanhoJanela.x <= 720) {
        this.expandirMenu()
      }
    },
    selecionarDocumento(documento, index, listagem, event) {
      this.$set(this.documentosAtivos, index, true)
      this.indiceDocumentoSelecionado = index
      this.listagemSelecionada = listagem

      if (event && event.target){
        this.documentoEstaSelecionado = true
        this.documentoBrancoSelecionado = true
      }

      if (
          ['AGUARDANDO_ANALISE'].includes(this.situacaoSolicitacaoCredenciamento) &&
          this.modoEdicao &&
          documento.situacao === 'AGUARDANDO_ANALISE' &&
          documento.novaSituacao !== 'AGUARDANDO_REENVIO'
      ) {
        documento.novaSituacao = 'APROVADO'
      }

      this.$emit('documentoSelecionado', documento)

      if (this.tamanhoJanela.x <= 720) {
        this.expandirMenu()
      }
    },
    handleResize () {
      this.tamanhoJanela = {
        x: window.innerWidth,
        y: window.innerHeight
      }
    },
    adicionarClasses(largura) {
      if (largura <= 720 && this.menuEstaAberto) {
        return 'analise-menu analise-menu__mobile analise-menu__mobile-aberto'
      } else if(largura <= 720 && !this.menuEstaAberto) {
        return 'analise-menu analise-menu__mobile analise-menu__mobile-fechado'
      } else {
        return 'analise-menu'
      }
    },
    expandirMenu() {
      this.menuEstaAberto = !this.menuEstaAberto
    },
    verificarSeExisteDocumentos() {
      return (this.value && this.value.documentosAnalizaveis.length > 0) || (this.value && this.value.documentosNaoAnalizaveis.length > 0)
    },
    selecionarDocumentoInicial() {
      if (this.value && this.value.documentosAnalizaveis.length > 0) {
          this.visualizarOuAnalisarDocumento(this.value.documentosAnalizaveis[0], 0)
          this.documentoEstaSelecionado = true
          this.documentoBrancoSelecionado = true
      }
    },
    async baixarTodosDocumentos() {
      let dados = {
        licitacaoId: this.$route.params.id,
        solicitacaoId: this.$route.params.idSolicitacao
      }

      await this.baixarTodosDocumentosFornecedor(dados)
    },
    abrirModalSolicitarNovoDocumento(){
      this.$store.commit(mutationTypes.CREDENCIAMENTO.SET_MOSTRAR_MODAL_SOLICITACAO_ENVIO_DOCUMENTO, true)
    },
    async solicitarEnvioNovoDocumento(data) {

      const documento =  {
          id: null,
          situacao: "AGUARDANDO_ENVIO",
          descricao: data.descricao,
          motivoReenvio: data.motivo,
          anexoUri: null
      }

      try {
        const response = await this.inserirNovoDocumentoSolicitacaoCredenciamento({
          credenciamentoId: this.$route.params.id,
          documento: {
            fornecedorId: this.value.fornecedor.id,
            anexo: documento
          }
        })

        if (response.status === 200) {
          this.mostrarNotificacaoSucesso(`Solicitação de envio realizada com sucesso`)
          this.$emit('reload')
        }

      } catch (error) {
        this.mostrarNotificacaoErro(`Houve um erro ao solicitar envio, por favor tente novamente mais tarde`)
      }
    },

    exibirAlertaDeAcordoCom(situacao) {
      return ['AGUARDANDO_REENVIO', 'REENVIADO', 'AGUARDANDO_ENVIO', 'ENVIADO_TEMPORARIO'].includes(situacao)
    },

    ehDocumentoAnalisado(documento){
      return documento.situacao === 'ANALISADO'
    },

    ...mapActions({
      baixarTodosDocumentosFornecedor: actionTypes.CREDENCIAMENTO.SOLICITACAO.BAIXAR_TODOS_DOCUMENTOS,
      inserirNovoDocumentoSolicitacaoCredenciamento: actionTypes.CREDENCIAMENTO.SOLICITACAO.INSERIR_NOVO_DOCUMENTO_SOLICITACAO_CREDENCIAMENTO
    }),

  },
  watch: {
    tamanhoJanela: {
      handler() {
        this.adicionarClasses(this.tamanhoJanela.x)
      }
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped lang="stylus">

.font-size-15
  font-size 15px


.analise-menu
  position relative
  width 20%
  background-color #eaeaea
  max-height 100%
  overflow-y auto
  height calc(100vh - 64px)

  &__titulo
    margin-bottom 0
    padding 14px 10px 10px
    background-color #a5a5a5
    height 44px
    text-align center
    text-transform uppercase
    color #fff
    font-size 12px
    font-weight bold

  &__lista
    padding-left 0
    font-size 12px

    &-item
      padding 20px 20px 20px 13px
      border-bottom 1px solid #a5a5a5
      color #555
      display flex
      justify-content space-between
      align-items center

    &-item:hover, &-item:focus, &-item:active
      background-color none !important
      cursor pointer

    &-item .icone
      color var(--v-primary-base)
      font-size 13px
      margin-left 5px

    .active
      color #fff
      background-color #0067a5

    .activeCheck
      color #0067a5
      background-color #dbdbdb !important

      &::before
        content: '\2713'
        color #0067a5

    .active:hover, .active:focus, .active:active
      background-color none !important

    .active .icone, .active .aviso, .active .aviso .icone
      color #fff

    .aviso
      color #ed8732
      display flex
      align-items center
      font-size 10px
      text-align right
      line-height 10px
      margin-left 5px

    .aviso .icone
      color #ed8732

  &__mobile
    z-index 1
    position absolute

    &-botao
      display none
      width 100%
      padding 10px
      color #777

    &-botao:hover, &-botao:active, &-botao:focus
      background-color #eee

    &-aberto
      width 70%
      .container-botoes-acoes
        display block

    &-fechado
      width 20%
      height 40px !important

.container-botoes-acoes
  position absolute
  bottom 0px
  width 100%
  overflow hidden

.wrapper-botoes-acoes
  display flex
  justify-content center
  flex-wrap wrap
  border-top 1px solid #a5a5a5

.wrapper-botoes-acoes > *
  flex 1 1 120px

.botao-baixar-todos
  display flex
  justify-content center
  text-align center

.botao-solicitar-documento
  display flex
  justify-content center
  text-align center

.btn-icone-reenvio
  margin 0
  width auto
  height auto

.btn-icone-reenvio::before
  background-color transparent !important

.icone-reenvio
  color #ed8732 !important
  font-size 15px !important
  pointer-events none !important

.icone-reenvio-selecionado
  color white !important

.scroll-area-documentos
  max-height calc(100vh - 240px)
  overflow-y auto

@media only screen and (min-width 1400px)
  .analise-menu__lista .active::after
    left 19.2%

@media only screen and (min-width 1600px)
  .analise-menu__lista .active::after
    left 19.4%

@media only screen and (max-width 950px)
  .analise-menu__titulo
    font-size 11px

@media only screen and (max-width 785px)
  .analise-menu__titulo
    font-size 10px

@media only screen and (max-width 720px)
  .analise-menu
    &__mobile-botao
      display block

    &__mobile-aberto &__titulo
      width 100%
      padding-top 15px

    &__lista .active::after
      right 0
      left auto
      border-top 8px solid transparent
      border-bottom 8px solid transparent
      border-right 10px solid #f8f9fa

    &__lista-item
      padding 13px

  .container-botoes-acoes
    display none
</style>